const graphStore = {
  state:{
    platformModuleStateData:[]
  },
  mutations:{
    SET_PLATFORM_MODULES_GRAPH_MUTATION:(state, payload) => {
      state.platformModuleStateData = payload
    },
    SET_NEW_GRAPH_ADD_MUTATION:(state, payload) => {
      
      
      state.platformModuleStateData[payload.index].data.push(payload.data)
      /* 
       */
    },
    DELETE_GRAPH_MUTATION:(state, payload) => {
      
      
      state.platformModuleStateData[payload.platformIndex].data.splice(payload.graphIndex, 1)
      /* 
       */
    }
  },
  actions:{
    SET_PLATFORM_MODULES_GRAPH_ACTION:({commit}, payload) => {
      commit('SET_PLATFORM_MODULES_GRAPH_MUTATION', payload)
    },
    Add_NEW_GRAPH_TO_MODULE_ACTION:({commit}, payload) => {
      commit('SET_NEW_GRAPH_ADD_MUTATION', payload)
    },
    DELETE_GRAPH_ACTION:({commit}, payload) => {
      commit('DELETE_GRAPH_MUTATION', payload)
    }
  },
  getters:{
    get_platform_modules_item_data: (state) => state.platformModuleStateData
  }
}
export default graphStore